import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useStorePickerContext } from "../../storePicker.context";
import { StorePickerType } from "../../types/storePickerType.enum";

export const StorePickerFooterComponent = () => {
    const { t } = useGranite();

    const { config } = useStorePickerContext();

    if (config.type === StorePickerType.INFO) return null;

    return (
        <div className="storePicker-layout--footer">
            <p className={cn("tw:hidden tw:md:block tw:mb-0")}>
                {config.displayStockLevel &&
                    config.type !== StorePickerType.SELECT_DRIVE_IN &&
                    t("general.storepicker.label.pickupTime")}
                {config.infoLink && (
                    <a
                        href={config.infoLink}
                        className={"ml-1"}
                    >
                        {t("general.storepicker.label.aboutCNC")}
                    </a>
                )}
            </p>
            {config.type === StorePickerType.CUSTOM && (
                <config.SubmitComponent />
            )}
        </div>
    );
};
